import { render, staticRenderFns } from "./CMPayments.vue?vue&type=template&id=31b1bcd8&"
import script from "./CMPayments.vue?vue&type=script&lang=js&"
export * from "./CMPayments.vue?vue&type=script&lang=js&"
import style0 from "./CMPayments.vue?vue&type=style&index=0&id=31b1bcd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports